export default "__VITE_ASSET__T$hGbkeZ__";